import { compact } from '../../../../helpers/compact';
import {
  DisclaimerSlice,
  LaPosteEn4SliceType,
} from '../../../../types/page/la-poste-en-4/slice';
import { toRichText } from '../../fields/text';
const disclaimerSlice = (
  data: Record<string, any>
): DisclaimerSlice | undefined => {
  const description = toRichText(data.primary?.description);
  if (!description) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4SliceType.DISCLAIMER,
    description,
  });
};

export default disclaimerSlice;
